import React from "react";
import Layout from "../Layouts/layout";
import "./orderKit.scss";
import { useNavigate } from "react-router-dom";

function KitCart() {
  const [items, setItems] = React.useState([]);
  const navigate = useNavigate();

  const loadCart = () => {
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    setItems(cart);
  };

  React.useEffect(() => {
    loadCart();
  }, []);

  const saveAndSync = (next) => {
    localStorage.setItem("cart", JSON.stringify(next));
    setItems(next);
  };

  const removeItem = (index) => {
    const next = items.filter((_, i) => i !== index);
    saveAndSync(next);
  };

  const clearCart = () => {
    saveAndSync([]);
  };

  const subtotal = items.reduce((sum, it) => sum + (it.totalPrice || 0), 0);
  const total = subtotal;

  return (
    <Layout>
      <div className="cartPage">
        <div className="cartHeader">
          <div className="cartHeaderLeft">
            <button
              className="backBtn"
              onClick={() => navigate("/app/order-kit")}
            >
              ←
            </button>
            <h1 className="cartTitle">Your Cart</h1>
          </div>
          {items.length > 0 && (
            <button className="clearCartBtn" onClick={clearCart}>
              Clear Cart
            </button>
          )}
        </div>

        <div className="cartContainer">
          <div className="cartContent">
            <div className="cartItems">
              <h2>Added Kits</h2>
              {items.length === 0 ? (
                <div className="emptyState">
                  <div className="emptyIcon">🛒</div>
                  <h3>No items yet</h3>
                  <p>Add tests to your cart to see them here.</p>
                  <button
                    className="backToKitsBtn"
                    onClick={() => navigate("/app/order-kit")}
                  >
                    Browse Kits
                  </button>
                </div>
              ) : (
                items.map((item, index) => (
                  <div className="cartItemCard" key={`${item.code}-${index}`}>
                    <div className="itemInfo">
                      <h4>{item.kitName}</h4>
                      <div className="itemName">{item.name}</div>
                      <div className="itemPrice">
                        ${item.totalPrice?.toFixed(2)}
                      </div>
                    </div>
                    <div className="itemActions">
                      <div
                        className="removeIconBtn"
                        aria-label="Remove"
                        onClick={() => removeItem(index)}
                      >
                        ×
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>

            <aside className="cartSummary">
              <h3 className="summaryTitle">Order Summary</h3>
              {items.length > 0 && (
                <div className="summaryItems">
                  {items.map((item) => (
                    <div className="summaryItem" key={item.code}>
                      <div className="summaryItemInfo">
                        <span className="summaryItemName">{item.name}</span>
                      </div>
                      <div className="summaryItemPrice">
                        ${(item.totalPrice || 0).toFixed(2)}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              <div className="summaryDivider" />
              <div className="summaryRow total">
                <span>Total</span>
                <span>${total.toFixed(2)}</span>
              </div>
              <button
                onClick={() => navigate("/app/kit-checkout")}
                className="checkoutBtn"
                disabled={items.length === 0}
              >
                Proceed to Checkout
              </button>
            </aside>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default KitCart;
